export interface IContact {
	[key: string]: any;
	LastName?: string;
	Fax?: string;
	Email?: string;
	Phone?: string;
	Title?: string;
	Jigsaw?: string;
	OwnerId?: string;
	AccountId?: string;
	Birthdate?: string;
	FirstName?: string;
	HomePhone?: string;
	OtherCity?: string;
	Department?: string;
	LeadSource?: string;
	OtherPhone?: string;
	OtherState?: string;
	Salutation?: string;
	Description?: string;
	MailingCity?: string;
	MobilePhone?: string;
	OtherStreet?: string;
	MailingState?: string;
	OtherCountry?: string;
	AssistantName?: string;
	MailingStreet?: string;
	AssistantPhone?: string;
	MailingCountry?: string;
	OtherPostalCode?: string;
	MailingPostalCode?: string;
	EmailBouncedDate?: string;
	EmailBouncedReason?: string;
}
